// extracted by mini-css-extract-plugin
export default {"container":"Table-module__container__k8t5p","table":"Table-module__table__ldXfq"};